import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent, watch, onUnmounted } from 'vue';
import ItemDetailBanner from './components/ItemDetailBanner.vue';
import ItemDetailBox from '@/components/ItemDetailBox.vue';
import ItemDetailNavBar from '@/components/ItemDetailNavBar.vue';
import { ItemService } from '@/services/item.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { useRoute, useRouter } from 'vue-router';
import { UserService } from '@/services/user.service';
import Sentry from '@/utils/sentry';
export default defineComponent({
  name: 'ItemDetail',
  components: {
    ItemDetailBanner: ItemDetailBanner,
    ItemDetailBox: ItemDetailBox,
    ItemDetailNavBar: ItemDetailNavBar
  },
  setup: function setup() {
    declareProviders([ItemService]);
    var userService = useService(UserService);
    var itemService = useService(ItemService);
    var route = useRoute();
    var router = useRouter();
    var id = +route.params.id;

    var updateContestInfo = function updateContestInfo() {
      itemService.getContestDetailInfo(id).catch(function (e) {
        Sentry.withScope(function (scope) {
          scope.setTag('api', 'updateContestInfo');
          scope.setLevel(Sentry.Severity.Error);
          Sentry.captureException(e);
        });
        router.replace({
          name: 'UserItemList'
        });
      });
    };

    onUnmounted(function () {
      itemService.clearTimer();
    });
    watch(function () {
      return userService.user;
    }, function () {
      updateContestInfo();
    }, {
      immediate: true
    });
    return {
      itemService: itemService
    };
  }
});